core.constant('firstLoginMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "UI": {
        "TABBAR": {
          "FIRST_LOGIN" : {
            "STEP_1" : "Krok 1",
            "STEP_2" : "Krok 2"
          }
        },
        "BREADCRUMB": {
        }
      },
      "MODULE": {
        "TITLE": {
        },
        "FIRST_LOGIN_CLINICS": {
          "WELCOME_IN_MEEDY_DOCTORS": "Witaj w Meedy Clinic"
        },
        "FIRST_LOGIN": {
          "WELCOME_IN_MEEDY_DOCTORS" : "Witaj w Meedy Doctors",
          "WELCOME_IN_VIPROTECT": "Witamy",
          "DESCRIPTION" : "Zapoznaj się z umową umożliwiającą Tobie legalne wprowadzanie informacji medycznych i danych osobowych pacjenta do systemu.",
          "NIP_DESCRIPTION" : "Wprowadź numer NIP prowadzonej przez Ciebie działalności gospodarczej/indywidualnej praktyki lekarskiej i kliknij „kontynuuj”.",
          "VIPROTECT_DECRIPTION" : "Aby móc w pełni korzystać z funkcjonalności naszego serwisu oraz żeby pacjenci mogli zapisać się na wizytę należy uzupełnić w pierwszej kolejności wszystkie wymagane dane osobowe, cennik i godziny dostępności.",
          "DOWNLOAD_PDF" : {
            "P1" : "Umowę możesz pobrać ",
            "LINK" : "tutaj"
          },
          "NIP" : "NIP",
          "STATEMENT" : "Oświadczam, że zapoznałem się z umowę umożliwiającą legalne wprowadzanie informacji medycznych i danych osobowych pacjenta do systemu.",
          "ADDRESS" : "Adres",
          "YES_FILL_DATA": "Tak, przechodzę do uzupełniania danych",
          "FILL_PRICE_LIST": "Dodaj cennik",
          "FILL_AVAILABILITY": "Uzupełnij dostępności",
          "FILL_DATA_STEP_2": "Uzupełnianie danych - krok 2",
          "FILL_DATA_STEP_3": "Uzupełnianie danych - krok 3",
          "GO_TO_CALENDAR": "Przejdź do Kalendarza",
          "FILL_DATA_END": "Uzupełnianie danych - zakończone"
        }
      }
    }
  }
});
